import { OktaAuthOptions } from '@okta/okta-auth-js'
import { Environment } from '../config/environment'

export function getOktaAuthConfig(env: Environment): OktaAuthOptions {
    return {
        clientId: env.oAuthClientId,
        issuer: `https://${env.oAuthDomain}/oauth2/default`,
        redirectUri: `${window.location.origin}${env.oAuthRedirectPath}`,
        logoutUrl: `${window.location.origin}${env.oAuthLogoutPath}`,
        scopes: ['kibsi:api', 'profile', 'email', 'openid'],
    }
}
